<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { wbsNodes } from "../lib/stores";
  import { workPackages } from "../lib/wbs";
  export let id: string | undefined = undefined;
  export let value: string | null = null;
  export let disabled = false;
  const dispatch = createEventDispatcher<{ change: string | null }>();
  $: packages = workPackages($wbsNodes);
  $: unknown = value && !packages.some((n) => n.id === value);
</script>

<select {id} aria-label="WBS work package" {disabled} value={value ?? ""}
  on:change={(e) => dispatch("change", e.currentTarget.value || null)}>
  <option value="">WBS to assign</option>
  {#if unknown}<option value={value}>Unrecognised WBS — select a work package</option>{/if}
  {#each packages as node (node.id)}
    <option value={node.id}>{node.code} — {node.name}</option>
  {/each}
</select>

<style>
  select { max-width:100%; min-width:140px; }
</style>
